<div>
    <mat-dialog-content>
        <strong >{{titulo}}</strong>
        <p>
            <img src="../../../assets/imagenes/logoFav.png" 
                style="float: left; width: 40px; margin-right: 20px;">
            <strong >{{texto}}</strong>
        </p>
    </mat-dialog-content>
</div>
